import React, { useState } from 'react';
import Slider from './Slider';
import logo from './../assets/images/logo.png';
import { Link } from 'react-router-dom';
import Navbar from './../pages/Navbar';
import Footer from './../pages/Footer';
import './../App.css';
import Advertisement from './../pages/Advertisement';
// import AdminSignup from './../pages/AdminSignup';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../apiConfig";



const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [serverError, setServerError] = useState("");
  // Instant state initialization from cache if available
  const [homeContent, setHomeContent] = useState(() => {
    try {
      const cached = localStorage.getItem("homeContent") || sessionStorage.getItem("homeContent");
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Background fetch to keep content fresh without blocking UI
  React.useEffect(() => {
    let isMounted = true;
    fetch(`${API_BASE_URL}/HomeBannerContent/getHomeContent`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data && isMounted) {
          setHomeContent(data);
          try {
            localStorage.setItem("homeContent", JSON.stringify(data));
            sessionStorage.setItem("homeContent", JSON.stringify(data));
          } catch (e) {
            console.error("Storage error:", e);
          }
        }
      })
      .catch((error) => console.error("Error fetching home content:", error));

    return () => {
      isMounted = false;
    };
  }, []);

  const validate = () => {
    const validationErrors = {};

    if (!email) validationErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(email)) validationErrors.email = 'Email is invalid';

    if (!password) validationErrors.password = 'Password is required';
    else if (password.length < 6) validationErrors.password = 'Password must be at least 6 characters';

    return validationErrors;
  };

  const getTodayKey = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${today.getFullYear()}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setServerError("");
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const cleanEmail = email.trim().toLowerCase();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/LoginRegistration/Login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: cleanEmail, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setServerError(data.message || "Invalid email or password");
        return;
      }

      localStorage.setItem("email", cleanEmail);

      if (data.requiresOtp || !data.token) {
        localStorage.removeItem("authToken");
        navigate('/otp-verification');
        return;
      }

      localStorage.setItem('authToken', data.token);
      const decodedToken = jwtDecode(data.token);
      localStorage.setItem("userRole", decodedToken.RoleBaseId);
      localStorage.setItem("userId", decodedToken.UserId);
      sessionStorage.removeItem("promoShown");
      navigate('/dashboard');
    } catch (err) {
      setServerError(err.message || "Unable to connect to server. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <Advertisement content={homeContent} />
      <div className="container d-flex align-items-center justify-content-center py-5" style={{ minHeight: '75vh' }}>
        <div className="d-flex flex-column justify-content-between w-100">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-7 col-md-7">
              <Slider banners={homeContent?.banners || homeContent?.Banners || []} />
            </div>
            <div className="col-lg-5 col-md-5">
              <div className="card card-default mb-0 shadow-sm border-0" style={{ borderRadius: '18px' }}>
                <div className="card-header pb-2">
                  <div className="app-brand w-100 d-flex justify-content-center border-bottom-0">
                    <Link className="w-auto pl-0 mt-2" to="/signin">
                      <img src={logo} alt="logo" loading="lazy" style={{ maxWidth: '170px', height: 'auto' }} />
                    </Link>
                  </div>
                  <div className="text-center mt-2">
                    <h5 className="text-dark mb-1 fw-bold">CHAKRAN MULTI SERVICES PVT LTD</h5>
                    <small className="text-muted d-block">Portal Registration Form</small>
                  </div>
                </div>
                <div className="card-body px-4 pb-4 pt-3">
                  <h4 className="text-dark mb-3 text-center">Sign In</h4>
                  {serverError && <div className="alert alert-danger">{serverError}</div>}
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="form-group col-md-12 mb-4">
                        <input
                          type="email"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control input-lg"
                          disabled={isSubmitting}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                      </div>
                      <div className="form-group col-md-12">
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control input-lg"
                            disabled={isSubmitting}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowPassword(!showPassword)}
                              disabled={isSubmitting}
                            >
                              <i className={`mdi ${showPassword ? "mdi-eye-off" : "mdi-eye"}`}></i>
                            </button>
                          </div>
                        </div>
                        {errors.password && <small className="text-danger">{errors.password}</small>}
                      </div>
                      <div className="col-md-12 mt-2">
                        <Link className="text-color" to="/forgotpassword"> Forgot password? </Link>
                      </div>
                      <div className="col-md-12">
                        <button
                          type="submit"
                          className="btn btn-primary btn-pill mb-2 mt-3 w-100"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <span>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Signing In...
                            </span>
                          ) : (
                            "Sign In"
                          )}
                        </button>
                        <p className="text-center mb-0">
                          Don't have an account yet? <Link className="text-blue" to="/signup"> Sign Up</Link>
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Login;


// import React, { useState } from 'react';
// import Slider from './Slider';
// import logo from './../assets/images/logo.png';
// import { Link } from 'react-router-dom';
// import Navbar from './../pages/Navbar';
// import Footer from './../pages/Footer';
// import './../App.css';
// import Advertisement from './../pages/Advertisement';
// // import AdminSignup from './../pages/AdminSignup';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useNavigate } from 'react-router-dom';
// import { jwtDecode } from "jwt-decode";
// import { API_BASE_URL } from "../apiConfig";
// import ReCAPTCHA from "react-google-recaptcha";


// const Login = () => {

//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate(); // For navigation
//   const [serverError, setServerError] = useState(""); // Added for API errors
//   const [reCaptchaToken, setReCaptchaToken] = useState(null);

//   const validate = () => {
//     const validationErrors = {};
//     if (!email) validationErrors.email = 'Email is required';
//     else if (!/\S+@\S+\.\S+/.test(email)) validationErrors.email = 'Email is invalid';

//     if (!password) validationErrors.password = 'Password is required';
//     else if (password.length < 6) validationErrors.password = 'Password must be at least 6 characters';

//     if (!reCaptchaToken) validationErrors.recaptcha = 'Please complete the reCAPTCHA verification';

//     return validationErrors;
//   };

//   const handleCaptchaChange = (token) => {
//     setReCaptchaToken(token);
//     if (token) {
//       setErrors((prevErrors) => ({ ...prevErrors, recaptcha: null }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setServerError(""); // Reset previous errors
//     const validationErrors = validate();

//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     try {
//       const response = await fetch(`${API_BASE_URL}/LoginRegistration/Login`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await response.json(); // Always parse response

//       if (!response.ok) {
//         setServerError(data.message || "Invalid email or password"); // Set error state
//         return; // Stop further execution
//       }

//       // Store the auth token in localStorage
//       localStorage.setItem('authToken', data.token);

//       // Decode the token
//       const decodedToken = jwtDecode(data.token);
//       console.log("Decoded Token:", decodedToken); // Debugging

//       // Extract RoleBaseId and store it
//       localStorage.setItem("userRole", decodedToken.RoleBaseId);
//       localStorage.setItem("userId", decodedToken.UserId);

//       // Store email in localStorage for OTP verification
//       localStorage.setItem("email", email);
//       console.log('Login successful:', data);

//       // Redirect to dashboard
//       //navigate("/otp-verification"); // Redirect with email
//       navigate('/dashboard');
//     } catch (err) {
//       setServerError(err.message); // Display the API message in UI
//       // console.log('Login failed', err);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <Advertisement />
//       <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '75vh' }}>
//         <div className="d-flex flex-column justify-content-between">
//           <div className="row justify-content-center">
//             <div className="col-lg-7 col-md-7">
//               <Slider />
//             </div>
//             <div className="col-lg-5 col-md-5">
//               <div className="card card-default mb-0">
//                 <div className="card-header pb-0">
//                   <div className="app-brand w-100 d-flex justify-content-center border-bottom-0">
//                     <Link className="w-auto pl-0 mt-3" to="/signin">
//                       <img src={logo} alt="logo" />

//                     </Link>
//                   </div>
//                 </div>
//                 <div className="card-body px-3 pb-3 pt-3">
//                   <h4 className="text-dark mb-3 text-center">Sign In</h4>
//                   {/* 🔴 Display server error if it exists */}
//                   {serverError && <div className="alert alert-danger">{serverError}</div>}

//                   {/* <form onSubmit={handleSubmit}> */}
//                   <form onSubmit={handleSubmit}>
//                     <div className="row">
//                       <div className="form-group col-md-12 mb-4">
//                         <input
//                           type="email"
//                           placeholder="Email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           className="form-control input-lg"
//                         />
//                         {errors.email && <small className="text-danger">{errors.email}</small>}
//                       </div>
//                       <div className="form-group col-md-12">
//                         <div className="input-group">
//                           <input
//                             type={showPassword ? "text" : "password"}
//                             placeholder="Password"
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                             className="form-control input-lg"
//                           />

//                           <div className="input-group-append">
//                             <button
//                               type="button"
//                               className="btn btn-outline-secondary"
//                               onClick={() => setShowPassword(!showPassword)}
//                             >
//                               <i className={`mdi ${showPassword ? "mdi-eye-off" : "mdi-eye"}`}></i>
//                             </button>
//                           </div>
//                         </div>
//                         {errors.password && <small className="text-danger">{errors.password}</small>}
//                       </div>

//                       <div className="form-group col-md-12 my-3 d-flex justify-content-center">
//                         <ReCAPTCHA
//                           sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" // Replace with your actual Google Recaptcha Site Key
//                           onChange={handleCaptchaChange}
//                         />
//                       </div>
//                       {errors.recaptcha && <div className="col-md-12 text-center"><small className="text-danger">{errors.recaptcha}</small></div>}

//                       <div>
//                         <Link className="text-color" to="/forgotpassword"> Forgot password? </Link>
//                       </div>
//                       <div className="col-md-12">
//                         <button type="submit" className="btn btn-primary btn-pill mb-2 mt-2">
//                           Sign In
//                         </button>
//                         <p>
//                           Don't have an account yet? <Link className="text-blue" to="/signup"> Sign Up</Link>
//                         </p>
//                         {/* <p>
//                           <Link className="text-blue" to="/AdminSignup">Admin login</Link>
//                         </p> */}
//                       </div>
//                     </div>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// }
// export default Login;
